import { format, isBefore, isValid, parse } from 'date-fns'
import { z } from 'zod'

const personalInfoSchema = z.object({
  email: z.string().email('E-mail inválido'),
  phone: z.string().min(1, 'Telefone é obrigatório'),
  rg: z.object({
    number: z.string().min(1, 'Número do RG é obrigatório'),
    date: z
      .string()
      .min(10, 'Data de emissão é obrigatória')
      .refine((value) => {
        return isValid(parse(value, 'dd/MM/yyyy', new Date()))
      }, 'A Data é inválida')
      .refine((value) => {
        return isBefore(parse(value, 'dd/MM/yyyy', new Date()), new Date())
      }, 'Data invalida')
      .transform((f) => format(f, 'dd/MM/yyyy')),
    uf: z.string().min(1, 'UF de emissão é obrigatória'),
    org: z.string().min(1, 'Órgão emissor é obrigatório'),
  }),
})

const addressSchema = z.object({
  zipCode: z.string().min(1, 'CEP é obrigatório'),
  street: z.string().min(1, 'Rua é obrigatória'),
  number: z.string().optional(),
  complement: z.string().optional(),
  neighborhood: z.string().min(1, 'Bairro é obrigatório'),
  city: z.string().min(1, 'Cidade é obrigatória'),
  state: z.string().min(1, 'Estado é obrigatório'),
})

const bankAccountSchema = z.object({
  bank: z.string().min(1, 'Banco é obrigatório'),
  agency: z.string().min(1, 'Agência é obrigatória'),
  account: z.string().min(1, 'Conta é obrigatória'),
  accountType: z.string().min(1, 'Tipo de conta é obrigatório'),
})

export const formSchema = z.object({
  personalInfo: personalInfoSchema,
  address: addressSchema,
  bankAccount: bankAccountSchema,
})

export type PersonalInfoData = z.infer<typeof personalInfoSchema>
export type AddressData = z.infer<typeof addressSchema>
export type BankAccountData = z.infer<typeof bankAccountSchema>
export type CreditClientFormData = z.infer<typeof formSchema>
